import { ComponentProps, FC } from "react";
import { Trans as OriginalTrans } from "react-i18next";
import { ParseKeys } from "i18next";

type Props = ComponentProps<typeof OriginalTrans>;

const baseComponents = {
  br: <br />,
  nobr: <span style={{ whiteSpace: "nowrap" }} />,
  Strong: <span style={{ fontWeight: "bold" }} />,
};

export const Trans: FC<Props> = ({ components, ...props }) => {
  const allComponents = components
    ? { ...baseComponents, ...components }
    : baseComponents;

  return <OriginalTrans components={allComponents} {...props} />;
};

export type I18nKey = ParseKeys;
